<template>
  <!-- 选择成员 -->
  <div class="my-select">
    <div class="select-div-top">
      <form action="/" class="logo-container">
        <div class="head">
          <van-search v-model="searchValue" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
            :clearable="true" clear-trigger="always" @clear="clearSearchValue">
            <template #left-icon>
              <van-icon name="search" />
            </template>
          </van-search>
          <div class="head-search" @click="isSearch = !isSearch" v-if="memberType === 0">
            <div class="icon-search"></div>
          </div>
        </div>
      </form>
      <div class="search-box" v-if="isSearch">
        <p class="title">术者类型</p>
        <ul class="search-menu">
          <li class="menu-li" :class="operatorRange === acc.value ? 'active' : ''" @click="changeSearch(acc)"
            v-for="(acc, index) in searchList" :key="index">{{ acc.name }}</li>
        </ul>
        <div class="footer">
          <div class="btn" @click="handleSerachReset">重 置</div>
          <div class="btn active" @click="handleSearchSave">确 认</div>
        </div>
      </div>
    </div>
    <ul class="list" v-if="list.length > 0">
      <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished" finished-text="我是有底线的"
        loading-text="正在加载..." @load="onLoad">
        <li v-for="(item, index) in list" :key="index" class="list-item" @click="changeList(item, index)">
          <img src="@/assets/images/grade/select.png" v-if="item.checkedPush" class="icon-check" alt="" />
          <img src="@/assets/images/teacher-task/un-select.png" v-else class="icon-check" alt="" />
          <img src="../../../assets/images/grade/icon-student.png" class="avatar" v-if="memberType != 1" />
          <img src="../../../assets/images/grade/icon-doctor.png" class="avatar" v-else />
          <div class="info">
            <div class="name" :class="memberType != 1 ? 'mb8' : ''">
              {{ item.realName }}
            </div>
            <template v-if="memberType != 1">
              <div class="currentLevel">
                <img src="../../../assets/images/grade/icon-current.png" alt="" class="icon-current" />
                <p class="level-title">{{ item.currentStageCj }}</p>
              </div>
              <div class="hospital">{{ item.hospitalName }}</div>
            </template>
          </div>
        </li>
      </van-list>
    </ul>
    <div class="empty-block" v-else>
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <button class="confirm-button" @click="handleOk" v-if="list.length">
      确定
    </button>
  </div>
</template>
<script>
import { debounce } from '@/utils/util'
import { getJohnsonUser, getUserClassStudent } from '@/api/grade'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'selectMember',
  data () {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
      list: [],
      searchValue: '',
      selectedList: [],
      adminsList: [],
      selectedIdList: [],
      selectedAdminIdList: [],
      memberType: 0,
      searchList: [{ name: '全部', value: '' }, { name: '目标术者', value: 'target' }, { name: '非目标术者', value: 'non-target' }, { name: 'Non-ep', value: 'non-ep' }],
      operatorRange: '',
      isSearch: false,
    }
  },
  created () {
    // 1 管理员 ， 0 成员
    this.memberType = +this.$route.query.memberType
    if (sessionStorage.getItem('createGrade')) {
      const { studentsList, adminsList } = JSON.parse(
        sessionStorage.getItem('createGrade')
      )
      this.selectedList = studentsList || []
      if (studentsList && studentsList.length) {
        this.selectedIdList = studentsList.map(acc => acc.id) || []
      }
      this.adminsList = adminsList || []
      if (adminsList && adminsList.length) {
        this.selectedAdminIdList = adminsList.map(acc => acc.id) || []
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    changeSearch (acc) {
      this.operatorRange = acc.value
    },
    handleSerachReset () {
      this.operatorRange = ''
      this.isSearch = false
      this.clearSearchValue()
    },
    handleSearchSave () {
      this.isSearch = false
      this.clearSearchValue()
    },
    changeList (val, index) {
      this.list[index].checkedPush = !this.list[index].checkedPush
      this.handleEachGroup(val)
      this.$forceUpdate()
    },

    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      let params = {
        realName: this.searchValue,
        memberType: this.memberType,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.memberType === 0) {
        params = {
          realName: this.searchValue,
          email: this.userInfo.email,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if (this.operatorRange) {
          params.operatorRange = this.operatorRange
        }
      }
      let url = this.memberType === 1
        ? getJohnsonUser(params)
        : getUserClassStudent({ ...params, employeeId: this.userInfo.employeeId })
      url.then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        this.list.forEach(acc => {
          if (this.memberType === 1) {
            if (this.selectedAdminIdList.includes(acc.id)) {
              acc.checkedPush = true
            }
          } else {
            if (this.selectedIdList.includes(acc.id)) {
              acc.checkedPush = true
            }
          }
        })
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },
    // 组装缓存
    eachStorage () {
      let changeListCon = {}
      let storageCon = {}
      if (sessionStorage.getItem('createGrade')) {
        storageCon = JSON.parse(sessionStorage.getItem('createGrade'))
      } else {
        storageCon = {
          className: '',
          adminsList: [],
          studentsList: []
        }
      }
      if (this.memberType === 1) {
        const adminsList = this.list.filter(acc => acc.checkedPush)
        let newList = this.adminsList.filter(
          itemB =>
            !this.list.some(
              itemA => itemA.id === itemB.id && itemA.checkedPush === false
            )
        )
        let newAdminList = this.adminsList.filter(acc => acc.roleType === 1)
        let list = [...newAdminList, ...newList]
        let set = new Set([...list, ...adminsList].map(item => item.id))
        let arr3 = Array.from(set).map(id => {
          return [...list, ...adminsList].find(item => item.id === id)
        })
        changeListCon = Object.assign(storageCon, { adminsList: arr3 })
      } else {
        const studentsList = this.list.filter(acc => acc.checkedPush)
        let newList = this.selectedList.filter(
          itemB =>
            !this.list.some(
              itemA => itemA.id === itemB.id && itemA.checkedPush === false
            )
        )

        let set = new Set([...newList, ...studentsList].map(item => item.id))
        let arr3 = Array.from(set).map(id => {
          return [...newList, ...studentsList].find(item => item.id === id)
        })
        changeListCon = Object.assign(storageCon, { studentsList: arr3 })
      }
      sessionStorage.setItem('createGrade', JSON.stringify(changeListCon))
    },
    // 判断一下，如果取消的学员在分组里面，要同步在分组删除
    handleEachGroup (item) {
      let { groupUsers = [], groupUsersList = [] } = JSON.parse(sessionStorage.getItem('createGrade'))
      if (groupUsers && groupUsers.length > 0 && !item.checkedPush) {
        groupUsers.forEach(itm => {
          if (itm.students && itm.students.length > 0) {
            itm.students = itm.students.filter(timStu => {
              if (timStu.id === item.id && timStu.groupRoleType === 1) {
                itm.leaderRealName = ''
              }
              return timStu.id !== item.id
            })
          }
        })
      }
      if (groupUsersList && groupUsersList.length > 0 && !item.checkedPush) {
        groupUsersList.forEach(itm => {
          if (itm.students && itm.students.length > 0) {
            itm.students = itm.students.filter(timStu => {
              if (timStu.id === item.id && timStu.groupRoleType === 1) {
                itm.leaderRealName = ''
              }
              return timStu.id !== item.id
            })
          }
        })
      }
      this.updateSessionStorage('createGrade', {
        groupUsersList,
        groupUsers
      })
    },
    updateSessionStorage (sessionStorageName, value) {
      let prevData = JSON.parse(sessionStorage.getItem(sessionStorageName))
      Object.keys(value).forEach(function (val, key) {
        prevData[val] = value[val]
      })
      sessionStorage.setItem(sessionStorageName, JSON.stringify(prevData))
    },
    handleOk () {
      this.eachStorage()
      this.$router.go(-1)
    },

    clearSearchValue () {
      this.searchValue = ''
      this.pageNum = 1
      this.pageSize = 10
      this.loading = false
      this.finished = false
      this.finishText = '没有更多了'
      this.list = []
      this.onLoad()
    },
    onCourseSearchEnter: debounce(function () {
      this.pageNum = 1
      this.pageSize = 10
      this.loading = false
      this.finished = false
      this.finishText = '没有更多了'
      this.list = []
      this.onLoad()
    }, 400)
  }
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.my-select {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: #F9F8F7;
  padding-top: 60px;

  .select-div-top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 60px;
    background-color: #F9F8F7;
  }

  .head {
    display: flex;
    align-items: center;
    position: absolute;
    padding-top: 12px;
    z-index: 2;
    top: 0;
    left: 10px;
    right: 10px;

    /deep/ .van-search {
      background: transparent;
      width: 100%;
      height: 40px !important;
      padding: 12px 0 16px 0;
      box-sizing: border-box;

      .van-search__content {
        border: 1px solid #F1EFED;
        background: rgba(255, 255, 255, 0.5);

        .van-field__control {
          color: #949BA5;
          font-weight: 400;
          font-size: 13px;
          &::placeholder {
            color: #949BA5;
            font-weight: 400;
            font-size: 13px;
          }
        }
      }

    }

    .head-search {
      margin-left: 10px;
      width: 51px;
      height: 40px;
      position: relative;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-search {
        width: 24px;
        height: 24px;
        background: url("../../../assets/images/grade/icon-search.png") no-repeat center center / 100% 100%;
      }
    }
  }

  .search-box {
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    height: 168px;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.1);
    padding: 14px 36px 20px 16px;
    box-sizing: border-box;

    .title {
      position: relative;
      padding-left: 10px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      margin-bottom: 13px;

      &::before {
        content: "";
        position: absolute;
        top: 6px;
        left: 0;
        width: 4px;
        height: 12px;
        background: #EB1700;
        border-radius: 30px;
      }
    }

    .search-menu {
      position: relative;
      list-style: none;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      .menu-li {
        width: 110px;
        height: 35px;
        background: #F2F3F7;
        border-radius: 8px 8px 8px 8px;
        margin-right: 7px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 13px;
        color: #6A7481;
        text-align: center;
        text-align: center;
        line-height: 34px;

        &.active {
          color: #EB1700;
        }
      }
    }

    .footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn {
        width: 144px;
        height: 40px;
        border-radius: 30px;
        border: 1px solid #989898;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: center;
        line-height: 39px;
        margin-right: 15px;

        &.active {
          color: #fff;
          background: #EB1700;
          border: none;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .list {
    overflow-y: auto;
    height: calc(100vh - 62px - 58px);
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 0 16px 16px;
    box-sizing: border-box;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .list-item {
      display: flex;
      align-items: center;
      background-color: #FFF;
      margin-bottom: 8px;
      padding: 14px 8px 12px;
      border-radius: 12px;

      .icon-check {
        width: 14px;
        height: 14px;
      }

      .avatar {
        width: 42px;
        height: 42px;
        margin-left: 8px;
        margin-right: 6px;
      }

      .info {
        flex: 1;
        overflow: hidden;

        .name {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          // margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .currentLevel {
          display: flex;
          align-items: center;
          margin-bottom: 3px;

          .icon-current {
            width: 31px;
            height: 15px;
            margin-right: 2px;
          }

          .level-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 14px;
            color: #7a8494;
            line-height: 20px;
          }
        }

        .mb8 {
          margin-bottom: 5px;
        }

        .hospital {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #7a8494;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .empty-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg,
        #ffffff 0%,
        #f6f8fa 6%,
        #edf1f4 8%,
        #f2f7fa 100%);
    height: calc(100vh - 62px);
    position: relative;
    top: 0;
    z-index: 2;

    .empty-img {
      width: 185px;
      display: block;
      margin-bottom: 4px;
    }

    .empty-txt {
      font-size: 12px;
      color: #949ba5;
      text-align: center;
    }
  }
}

.confirm-button {
  height: 42px;
  margin: 0 10px;
  width: calc(100% - 20px);
  background-color: #eb1700;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 42px;
  box-sizing: border-box;
  border: none;
  border-radius: 22px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/selectMember.vue